<template>
    <!-- begin:: Header -->
    <header class="ct-header ct-header-fixed">
        <!-- begin:: Header Topbar -->
        <nav class="navbar navbar-expand-sm navbar-light w-100" :class="clsLeftBordered">
            <div class="d-flex align-items-center">
                <!--
                showtop {{hasNavTopMenu}}<br />
                comparacao {{(hasNavTopMenu && hasMainSidebarSlot)}}<br />
                hasslot {{hasMainSidebarSlot}}<br />
                -->
                <button class="navbar-toggler-sidebar" :class="classToggler" type="button" data-toggle="collapse"
                    data-target="" aria-controls="" aria-expanded="false"
                    aria-label="Toggle sidebar" @click="toggleMenuSideBar()">
                    <span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span>
                </button>
                 <router-link
                    :to="{ name: initialPagePlatform }"
                    class="navbar-brand py-0 ml-sm-2 mr-0 mr-md-2"
                    :class="{'d-lg-none': $route.meta.hideHeaderName}"
                >
                    <div class="row no-gutters">
                        <div class="col-auto">
                            <template v-if="hasNavTopMenu">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header.svg')" class="d-none d-lg-block only-img">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-tablet.svg')" class="d-none d-sm-block d-lg-none only-img">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-mobile.svg')" class="d-block d-sm-none only-img">
                                <h6 class="text-nowrap d-block d-sm-none m-0 module-name" v-if="moduleName">{{ moduleName }}</h6>
                            </template>
                            <template v-else>
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header.svg')" class="d-none d-lg-block">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-tablet.svg')" class="d-none d-sm-block d-lg-none">
                                <img alt="Logo" :src="assetsPathGlobalPlatform('/logo-header-mobile.svg')" class="d-block d-sm-none">
                                <h6 class="text-nowrap m-0 module-name" v-if="moduleName">{{ moduleName }}</h6>
                            </template>
                        </div>
                    </div>
                </router-link>
            </div>
            <div class="navbar-collapse justify-content-between align-items-center w-auto w-sm-100">
                <div class="navbar-nav text-center" :class="{'mx-auto': !activeSearchPortal, 'navbar--portal': activeSearchPortal}">
                    <!-- <search-portal v-if="activeSearchPortal" key="search-portal"></search-portal> -->
                    <!-- <search-box v-else-if="activeSearchPanel" key="search-box" :moduleCode="moduleCode"></search-box> -->
                    <search-box v-if="activeSearchPanel" key="search-box" :moduleCode="moduleCode"></search-box>
                </div>
                <div class="nav navbar-nav flex-row justify-content-end flex-nowrap">

                    <!-- TOOLS -->
                    <template v-for="tool in tools">
                        <component
                            :is="`${tool.component}HeaderTool`"
                            :key="tool.component"
                            :title="$t(tool.title)"
                            :moduleCode="moduleCode"
                            :propIdPanel="tool.id ?? tool.component"
                            :hasNavTopMenu="hasNavTopMenu">
                        </component>
                    </template>

                     <!-- USER -->
                    <div class="dropdown">
                        <template v-if="$auth.check()">
                            <!-- d-flex align-items-center justify-content-center -->
                            <a
                                href="#"
                                role="button"
                                class="header-icon"
                                id="dropdownMenuUser"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                aria-haspopup="true">
                                <div class="media topbar-user">
                                    <img :src="($auth.user().photo ? $auth.user().photo : avatar)"
                                        class="align-self-center profile-image ml-1 ml-sm-2 ml-md-3"
                                        :title="[$auth.user().name]"
                                        data-toggle="tooltip-city"
                                        :alt="$auth.user().name">
                                    <div class="media-body align-self-center"
                                        :title="$t(`auth.user.menu`)"
                                        data-toggle="tooltip-city">
                                        <div class="d-none d-md-flex flex-column text-left p-0 ml-2">
                                            <span class="d-inline-block text-welcome">
                                                {{ $t(`auth.user.prefix-name-welcome`) }}
                                            </span>
                                            <span class="d-inline-block text-username text-truncate text-truncate-header">
                                                {{$auth.user().name}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-animated dropdown-lg" aria-labelledby="dropdownMenuUser" x-placement="bottom-start">
                                <div class="dropdown-header bg-trans-gradient d-flex flex-row py-3 rounded-top">
                                    <div class="d-flex flex-column flex-fill align-items-start mt-1 mb-1 text-white">
                                        <div class="mb-2 mx-auto">
                                            <img :src="($auth.user().photo ? $auth.user().photo : avatar)" class="rounded-circle profile-image" :alt="$auth.user().name">
                                        </div>
                                        <div class="info-card-text">
                                            <div class="text-truncate text-truncate-lg">{{ $auth.user().name }}</div>
                                            <span class="text-truncate text-truncate-md opacity-80">{{ $auth.user().email }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dropdown-divider m-0"></div>
                                <router-link
                                    v-if="hasAccess('portal.profile')"
                                    :to="{ name: 'portal.profile' }"
                                    class="dropdown-item"
                                    data-toggle="modal"
                                    data-target="">
                                    <span data-i18n="">{{ $t(`auth.profile`) }}</span>
                                </router-link>
                                <div class="dropdown-divider m-0"></div>
                                <router-link
                                    v-if="hasAccess('portal.dashboard')"
                                    :to="{ name: 'portal.dashboard' }"
                                    class="dropdown-item"
                                    data-toggle="modal"
                                    data-target="">
                                    <span data-i18n="">{{ $t(`dashboard.title`) }}</span>
                                </router-link>
                                <!-- <div class="dropdown-divider m-0"></div>
                                <a href="#" class="dropdown-item" data-toggle="modal" data-target=".js-modal-settings">
                                    <span data-i18n="drpdwn.settings">Preferências</span>
                                </a>
                                <a href="#" class="dropdown-item" data-action="app-fullscreen">
                                    <span data-i18n="drpdwn.fullscreen">Fullscreen</span>
                                    <i class="float-right text-muted">F11</i>
                                </a>
                                <a href="#" class="dropdown-item" data-action="app-print">
                                    <span data-i18n="drpdwn.print">Print</span>
                                    <i class="float-right text-muted">Ctrl + P</i>
                                </a>
                                <div class="dropdown-multilevel dropdown-multilevel-left">
                                    <div class="dropdown-item">
                                        Linguagem
                                    </div>
                                    <div class="dropdown-menu">
                                        <a href="#?lang=pt" class="dropdown-item" data-action="lang" data-lang="pt">Português</a>
                                        <a href="#?lang=en" class="dropdown-item active" data-action="lang" data-lang="en">English (US)</a>
                                        <a href="#?lang=es" class="dropdown-item" data-action="lang" data-lang="es">Español</a>
                                    </div>
                                </div> -->
                                <div class="dropdown-divider m-0"></div>
                                <!-- <a href="" @click.prevent.stop="logout" class="dropdown-item fw-500 pt-3 pb-3">
                                    <span data-i18n="">Logout</span>
                                    <span class="float-right fw-n">@cityhub</span>
                                </a> -->
                                <router-link
                                    :to="{ name: 'portal.logout' }"
                                    class="dropdown-item fw-500 pt-3 pb-3"
                                    data-toggle="modal"
                                    data-target="">
                                    <span data-i18n="">{{ $t(`auth.actions.logout`) }}</span>
                                    <span class="float-right fw-n">@cityhub</span>
                                </router-link>
                            </div>
                        </template>
                        <template v-else>
                            <router-link
                                :to="{ name: 'portal.login' }"
                                :title="$t(`auth.actions.login`)"
                                class="header-icon ml-0 ml-sm-3" >
                                <div class="media topbar-user">
                                    <img :src="loginIcon"
                                        class="align-self-center"
                                        :alt="$t(`auth.actions.login`)">
                                    <div class="media-body align-self-center">
                                        <div class="d-none d-md-flex flex-column text-left p-0 ml-2">
                                            <span class="d-inline-block text-welcome font-small">{{ $t(`auth.actions.login`) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </template>
                    </div>
                </div>
            </div>

        </nav>
        <!-- end:: Header Topbar -->
    </header>
    <!-- end:: Header -->
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import defaultAvatar from '@images/avatar.png';
    import LoginIcon from '@images/icons/login.svg';

    export default {
        components: {
            SearchBox: () => import(/* webpackChunkName: "search-box" */ './NavSearchBox'),
            SearchPortal: () => import(/* webpackChunkName: "search-portal" */ './NavSearchPortal'),
            ActivityHeaderTool: () => import(/* webpackChunkName: "activity-header-tool" */ './components/activityHeaderTool'),
            OverdueHeaderTool: () => import(/* webpackChunkName: "overdue-header-tool" */ './components/overdueHeaderTool'),
            DashboardHeaderTool: () => import(/* webpackChunkName: "dashboard-header-tool" */ './components/dashboardHeaderTool'),
            AccountableHeaderTool: () => import(/* webpackChunkName: "accountable-header-tool" */ './components/accountableHeaderTool'),
        },
        mixins: [
            GlobalMixin,
        ],
        props: {
            hasMainSidebarSlot: {
                type: Boolean,
                default: false
            },
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            showBorderTopLeft: {
                type: Boolean,
                default: false
            },
            hasNavTopMenu: {
                type: Boolean,
                default: false
            },
            activeSearchPortal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                pageID: 'headernav',
                idPanelSearch: 'navsearch',
            }
        },
        computed: {
            avatar() {
                return defaultAvatar;
            },
            loginIcon() {
                return LoginIcon;
            },
            tools(){
                return typeof this.getPanel === 'function' ? this.getPanel(this.moduleCode, this.pageID).tools : [];
            },
            classToggler() {
                if (this.hasNavTopMenu && this.hasMainSidebarSlot) return 'd-lg-none';
                if (!this.hasNavTopMenu && this.hasMainSidebarSlot) return 'd-lg-none';
                return 'd-sm-none';
                // return {
                //     'd-sm-none': !(this.hasNavTopMenu && this.hasMainSidebarSlot),
                //     'd-lg-none': (this.hasNavTopMenu && this.hasMainSidebarSlot)
                // }
            },
            moduleName(){
                return this.$store.getters.getModuleName(this.moduleCode);
            },
            getPanel(){
                return this.$store.getters.getPanel;
            },
            getStateTool(){
                return this.moduleCode ? this.$store.getters.getStateTool : null;
            },
            clsLeftBordered () {
              return this.showBorderTopLeft ? 'left-bordered' : '';
            },
            activeSearchPanel() {
                return typeof this.getStateTool === 'function' ? this.checkPermissionPanel(this.getStateTool(this.moduleCode, this.idPanelSearch), this.idPanelSearch) : false;
            },
        },
        methods: {
            hasAccess(routeName) {
                const profileRoute = this.$router.getRoutes().find((route) => {
                    return route.name == routeName;
                });
                if(profileRoute.meta.auth == undefined) {
                    return true;
                }
                return this.$auth.check(profileRoute.meta.auth.roles[0]);
            },
            openPanel(id){
                return this.$store.dispatch(`${this.moduleCode}/openPanel`, id);
            },
            toggleMenuSideBar () {
                this.$emit('toggleClick');
            },
            logout: function() {
                this.$router.push({ name: `portal.logout` })
            },
        },
    }
</script>

<style scoped lang="scss">
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";

.theme-switch {
    background-color: $body-bg-color !important;
}

.ct-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: relative;
    z-index: $zindex-main-header;
    height: $navbar-header-height;
    @include sm {
        height: $navbar-header-height-sm;
    }
    .navbar {
        .navbar-toggler-sidebar {
            color: $navbar-module-name-color;
            @include sm {
                color: $navbar-module-name-color-sm;
            }
        }

        .navbar-brand {
            white-space: normal;

            .module-name {
                line-height: 1.45;
                font-size: 0.688rem;
                text-transform: $navbar-module-name-text-transform;
                font-family: $navbar-module-name-font;
                color: $navbar-module-name-color;
                @include sm {
                    color: $navbar-module-name-color-sm;
                }
            }

            img {
                max-width: 155px;
                @include sm {
                    max-width: 100%;
                }
                // @include sm {
                //     max-width: 170px;
                // }
                // @include md {
                //     max-width: 250px;
                // }
                // @include lg {
                //     max-width: 100%;
                // }
            }

            @include lg {
                img.only-img {
                    max-width: 350px;
                }
            }
            @include xl {
                img.only-img {
                    max-width: 430px;
                }
            }

            @include xxl {
                img.only-img {
                    max-width: 550px;
                }
            }
        }
    }

    &.ct-header-fixed {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: $zindex-main-header;
        // z-index: inherit;
    }
}



/* @media (min-width: 576px){ */
@include sm {
    .ct-header {
        background-color: $side-menu-bg-color;
        // border-bottom: 1px solid #eff0f6;
        @include sm {
            background-color: $navbar-header-bg-color-sm;
        }
        @media (min-width: 1025px) {
            background-color: $navbar-header-bg-color;
        }

        .ct-header-mobile {
            display: none;
        }

        // &.ct-header-fixed {
        //     position: fixed;
        //     top: 0;
        //     right: 0;
        //     left: 0;
        //     z-index: $zindex-main-header;
        //     // z-index: inherit;
        // }
    }
    .module-portal {
        .ct-header {
            &.ct-header-fixed {
                z-index: $zindex-main-header;
            }
        }
    }
}
@media (max-width: 1024px){
    .ct-header-mobile{

    }
}
@media (min-width: 1025px){
    .ct-header {

        .navbar-toggler-sidebar {
            display: none;
        }

        // &.ct-header-fixed {
        //     position: fixed;
        //     top: 0;
        //     right: 0;
        //     left: 0;
        //     z-index: $zindex-main-header;
        // }
    }

    .ct-header-fixed:not(.ct-aside-only-mobile) {
        .ct-header {
            &.ct-header-fixed {
                left: $navbar-sidebar-width;
            }
        }
    }
}
</style>

<style lang="scss">
@import "@styles/bootstrap/_mixins.scss";
@import "@styles/_theme.scss";
@include media-breakpoint-down(sm) {
    .ct-content {
        margin-top: $navbar-header-height;
    }
}
</style>
